import { ImportStatusGroup } from '../smartsend/SmartSendSocketsModels';
import ImportStatusChip from './ImportStatusChip';
import Time from '../Time';
import { P2GGrid, P2GBox, P2GText } from '@parcel2go/core-ui';

interface props {
  group: ImportStatusGroup;
  children: React.ReactNode;
}

const ImportStatusItemIndicator: React.FC<props> = (props) => {
  const hasDetails = !!props.group;
  return (
    <P2GGrid container wrap="nowrap" gap={1} alignItems="center" alignContent="center">
      <P2GGrid item flexGrow={1}>
        <P2GBox>{props.children}</P2GBox>
        <P2GBox>
          <P2GText variant="caption">
            {hasDetails ? <>Completed at {Time(props.group.SentTime)}</> : <>Starting shortly...</>}
          </P2GText>
        </P2GBox>
      </P2GGrid>
      <P2GGrid item>
        {hasDetails ? (
          <ImportStatusChip notification={props.group.Updates[0]} />
        ) : (
          <ImportStatusChip notification={undefined} override={'QUEUED'} />
        )}
      </P2GGrid>
    </P2GGrid>
  );
};
export default ImportStatusItemIndicator;
